export type Pacing = 'not-started' | 'on-track' | 'behind' | 'ahead' | 'completed';

export function computePacing(startDate: string, endDate: string, progressPct: number) {
  const start = new Date(startDate).getTime();
  const end = new Date(endDate).getTime();
  const now = Date.now();
  const total = end - start;
  const elapsed = Math.max(0, Math.min(total, now - start));
  const todayPct = total > 0 ? (elapsed / total) * 100 : 0;
  const delta = progressPct - todayPct;

  let pacing: Pacing;
  if (now < start) pacing = 'not-started';
  else if (now > end) pacing = 'completed';
  else if (delta >= 5) pacing = 'ahead';
  else if (delta <= -10) pacing = 'behind';
  else pacing = 'on-track';

  return { todayPct, delta, pacing };
}

export const pacingLabel: Record<Pacing, string> = {
  'not-started': 'Not started',
  'on-track': 'On track',
  'behind': 'Behind',
  'ahead': 'Ahead',
  'completed': 'Completed',
};

export const pacingClasses: Record<Pacing, { dot: string; text: string; fill: string }> = {
  'not-started': { dot: 'bg-neutral-400', text: 'text-neutral-500', fill: 'bg-neutral-400' },
  'on-track':    { dot: 'bg-emerald-500', text: 'text-emerald-700', fill: 'bg-emerald-500' },
  'ahead':       { dot: 'bg-emerald-500', text: 'text-emerald-700', fill: 'bg-emerald-500' },
  'behind':      { dot: 'bg-amber-500',   text: 'text-amber-700',   fill: 'bg-amber-500' },
  'completed':   { dot: 'bg-blue-500',    text: 'text-blue-700',    fill: 'bg-blue-500' },
};
